import React, { useState } from "react";
import "./memberlogin.css";
import { useNavigate } from "react-router-dom";
import logo from "../assets/icons/CDR-Logo.png";
import bgImage from "../assets/icons/dinning.png";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/MemberLogin/MemberDetail");
  };

  return (
    <div
      className="auth-wrapper"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="auth-overlay" />

      <div className="auth-card">
        <img src={logo} alt="logo" className="auth-brand" />

        <h1 className="auth-heading-primary">LA CHAÎNE</h1>
        <h2 className="auth-heading-secondary">DES RÔTISSEURS</h2>

        <div className="auth-separator" />

        <p className="auth-location">VIETNAM CHAPTER</p>

        <div className="auth-field">
          <label>Email Address</label>
          <input type="email" placeholder="Enter your email" />
        </div>

        <div className="auth-field">
          <label>Password</label>

          <div className="auth-pass-box">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
            />

            <button
              type="button"
              className="auth-pass-visibility"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
        </div>

        <div className="auth-actions">
          <label className="auth-remember-me">
            <input type="checkbox" />
            Remember Me
          </label>

          <a href="/" className="auth-forgot-link">
            Forgot Password?
          </a>
        </div>

        <button className="auth-submit-btn" onClick={handleLogin}>
          SIGN IN
        </button>
        <div className="auth-divider-section">
          <span />
          <p>OR</p>
          <span />
        </div>

        <button
          className="auth-register-link"
          onClick={() => navigate("/MemberRegistration")}
        >
          NEW MEMBER? REGISTER HERE
        </button>

        <p className="auth-footer-message">
          EXCELLENCE IN GASTRONOMY, HOSPITALITY & FRIENDSHIP
        </p>
      </div>
    </div>
  );
}
